import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(6),
    maxWidth: 400,
  },
  buttonsContainer: {
    display: "flex",
    gap: theme.spacing(2),
  },
  button: {
    width: "200px",
  },
}));
